import React from "react";

import AccordionDetails from "@mui/material/AccordionDetails";
import styled from "@mui/material/styles/styled";

import { AccordionSummary } from "@rui/Accordion";
import Button from "@rui/Button";
import TextField, { TextFieldProps } from "@rui/TextField";

export const FooterButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#FFF",
  borderColor: theme.palette.shades.neutral[150],
  color: theme.palette.shades.neutral[800],
  minWidth: "88px",
}));

export const MessageInput = styled<React.FC<TextFieldProps>>((props) => (
  <TextField
    multiline
    rows={3}
    placeholder="Type your message here"
    {...props}
  />
))(({ theme }) => ({
  "& .MuiInputBase-root": {
    padding: 0,
    "& textarea": {
      padding: theme.spacing(1, 1.5),
      fontSize: "0.875rem",
    },
  },
}));

export const CustomizeAccordionSummary = styled(AccordionSummary)(
  ({ theme }) => ({
    padding: 0,
    fontWeight: 500,
    justifyContent: "flex-start",
    minHeight: 0,
    "& .MuiAccordionSummary-content": {
      width: "fit-content",
      flexGrow: 0,
      margin: 0,
      marginRight: theme.spacing(1),
    },
  })
);

export const CustomizeAccordionDetails = styled(AccordionDetails)(
  ({ theme }) => ({
    padding: 0,
    paddingLeft: theme.spacing(0.5),
  })
);
